// extracted by mini-css-extract-plugin
export var divider = "_rp-0";
export var systemMessage = "_rp-1";
export var systemMessageWrapper = "_rp-2";